module.exports = __webpack_public_path__ + "static/media/womanlift.4d3dba1e.gif";